import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ReportsService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  requestDesonerados() {
    return this.http.get(`${this.serviceApi}/v1/dominio-reports/desonerados-report`);
  }
  requestTomados(inicial: string, final: string) {
    return this.http.get(`${this.serviceApi}/v1/dominio-reports/tomados-report?inicial=${inicial}&final=${final}`);
  }
  requestPrestados(inicial: string, final: string) {
    return this.http.get(`${this.serviceApi}/v1/dominio-reports/prestados-report?inicial=${inicial}&final=${final}`);
  }
}
